/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsCumulativeHistogram } from '../../models/profile-analytics-cumulative-histogram';

export interface ProfileReferralsHistogramDateHistogram$Params {
  id: number;
  referral: string;
}

export function profileReferralsHistogramDateHistogram(http: HttpClient, rootUrl: string, params: ProfileReferralsHistogramDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
  const rb = new RequestBuilder(rootUrl, profileReferralsHistogramDateHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('referral', params.referral, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>;
    })
  );
}

profileReferralsHistogramDateHistogram.PATH = '/analytics/profile/{id}/referrals/histogram';
